// src/Views/TestimonialCard.js
import React from 'react';
import {
  SPACING_MICRO,
  SPACING_TIGHT,
  SPACING_BUTTON,
  SPACING_CARD,
  SPACING_GROUP,
  BORDER_RADIUS,
} from '../constants/layout';
import { FONT_BODY, FONT_SUBHEADLINE } from '../constants/typography';

export default function TestimonialCard({ name, location, text, stars = 5 }) {
  return (
    <div className="testimonial-card">
      <div className="testimonial-author-section">
        <p className="testimonial-name">{name}</p>
        {location && <p className="testimonial-location">{location}</p>}
      </div>
      <p className="testimonial-text">{text}</p>
      <div className="testimonial-rating" aria-label={`${stars} out of 5 stars`}>
        {Array.from({ length: stars }).map((_, i) => (
          <span key={i} className="material-icons star-icon" aria-hidden="true">star</span>
        ))}
      </div>

      <style jsx>{`
        .testimonial-card {
          padding: ${SPACING_BUTTON} ${SPACING_CARD};
          border-radius: ${BORDER_RADIUS};
          background-color: var(--color-surface);
          border: 1px solid var(--color-border);
          display: flex;
          flex-direction: column;
          justify-content: center;
          gap: ${SPACING_BUTTON};
          box-sizing: border-box;
        }

        .testimonial-rating {
          display: flex;
          gap: ${SPACING_TIGHT};
        }

        .star-icon {
          font-size: 20px;
          color: #FFB800;
          vertical-align: middle;
        }

        .testimonial-text {
          font-size: ${FONT_BODY};
          color: var(--color-text-primary);
          margin: 0;
          line-height: 1.7;
          font-style: italic;
        }

        .testimonial-text :global(.highlight) {
          background-color: #fef08a;
          padding: ${SPACING_MICRO} ${SPACING_TIGHT};
          border-radius: 3px;
          font-style: italic;
        }

        .testimonial-author-section {
          margin-bottom: ${SPACING_BUTTON};
          text-align: left;
        }

        .testimonial-name {
          font-size: ${FONT_SUBHEADLINE};
          color: var(--color-text-primary);
          font-weight: 600;
          margin: 0 0 ${SPACING_TIGHT} 0;
        }

        .testimonial-location {
          font-size: ${FONT_SUBHEADLINE};
          color: var(--color-text-secondary);
          margin: 0;
        }

        @media (max-width: 480px) {
          .testimonial-card {
            padding: ${SPACING_GROUP} ${SPACING_GROUP};
          }
        }
      `}</style>
    </div>
  );
}
